import types from "./types";

const INITIAL_STATE = {
	technicaldocument: null,
	technicaldocumentError: null,
	technicaldocumentLoading: false,

	//create
	createtechnicaldocument: null,
	createtechnicaldocumentError: null,
	createtechnicaldocumentLoading: false,

	//update
	updatetechnicaldocument: null,
	updatetechnicaldocumentError: null,
	updatetechnicaldocumentLoading: false,

	//delete
	deletetechnicaldocument: null,
	deletetechnicaldocumentError: null,
	deletetechnicaldocumentLoading: false,

	//single item

	singleItem: null,
};

const TechnicalDocumentReducer = (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case types.GET_TECHNICALDOCUMENT_START:
			return {
				...state,
				technicaldocument: null,
				technicaldocumentError: null,
				technicaldocumentLoading: true,
			};
		case types.GET_TECHNICALDOCUMENT_SUCCESS:
			return {
				...state,
				technicaldocument: action.payload,
				technicaldocumentLoading: false,
			};
		case types.GET_TECHNICALDOCUMENT_ERROR:
			return {
				...state,
				technicaldocumentError: action.payload,
				technicaldocumentLoading: false,
			};
		case types.GET_TECHNICALDOCUMENT_RESET:
			return {
				...state,
				technicaldocumentError: null,
				technicaldocumentLoading: false,
			};
		//create

		case types.CREATE_TECHNICALDOCUMENT_START:
			return {
				...state,
				createtechnicaldocument: null,
				createtechnicaldocumentError: null,
				createtechnicaldocumentLoading: true,
			};
		case types.CREATE_TECHNICALDOCUMENT_SUCCESS:
			return {
				...state,
				createtechnicaldocument: action.payload,
				createtechnicaldocumentLoading: false,
			};
		case types.CREATE_TECHNICALDOCUMENT_ERROR:
			return {
				...state,
				createtechnicaldocumentError: action.payload,
				createtechnicaldocumentLoading: false,
			};
		case types.CREATE_TECHNICALDOCUMENT_RESET:
			return {
				...state,
				createtechnicaldocumentError: null,
				createtechnicaldocumentLoading: false,
			};
		//delete

		case types.DELETE_TECHNICALDOCUMENT_START:
			return {
				...state,
				deletetechnicaldocument: null,
				deletetechnicaldocumentError: null,
				deletetechnicaldocumentLoading: true,
			};
		case types.DELETE_TECHNICALDOCUMENT_SUCCESS:
			return {
				...state,
				deletetechnicaldocument: action.payload,
				deletetechnicaldocumentLoading: false,
			};
		case types.DELETE_TECHNICALDOCUMENT_ERROR:
			return {
				...state,
				deletetechnicaldocumentError: action.payload,
				deletetechnicaldocumentLoading: false,
			};
		case types.DELETE_TECHNICALDOCUMENT_RESET:
			return {
				...state,
				deletetechnicaldocument: null,
				deletetechnicaldocumentError: null,
				deletetechnicaldocumentLoading: false,
			};

		//update
		case types.UPDATE_TECHNICALDOCUMENT_START:
			return {
				...state,
				updatetechnicaldocument: null,
				updatetechnicaldocumentError: null,
				updatetechnicaldocumentLoading: true,
			};
		case types.UPDATE_TECHNICALDOCUMENT_SUCCESS:
			return {
				...state,
				updatetechnicaldocument: action.payload,
				updatetechnicaldocumentLoading: false,
			};
		case types.UPDATE_TECHNICALDOCUMENT_ERROR:
			return {
				...state,
				updatetechnicaldocumentError: action.payload,
				updatetechnicaldocumentLoading: false,
			};
		case types.UPDATE_TECHNICALDOCUMENT_RESET:
			return {
				...state,
				updatetechnicaldocument: null,
				updatetechnicaldocumentError: null,
				updatetechnicaldocumentLoading: false,
			};
		
		default:
			return { ...state };
	}
};

export default TechnicalDocumentReducer;
